import { useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectAllCount } from '../../selectors/folders';
import { useApplicationContext } from '../../utils/applicationContext';
import { sendUXSEvent } from '../../utils/uxs';

type TUxfeedbackCompaniesNames = {
  desktop: string;
  mobile: string;
};

export const useFavoritesUxfeedbackCampaign = () => {
  const device = useDeviceType();
  const { config } = useApplicationContext();

  const entitiesCount = useSelector(selectAllCount);
  const requiredEntitiesCount = config.get<number>('uxfeedback.favorites.requiredEntitiesCount') || 2;
  const companiesNames = config.get<TUxfeedbackCompaniesNames>('uxfeedback.favorites.companiesNames') || {
    desktop: 'AudMonFavoriteDesktop',
    mobile: 'AudMonFavoriteMobWeb',
  };

  const sendFavoritesUxfeedbackCampaign = React.useCallback(() => {
    if (requiredEntitiesCount && entitiesCount >= requiredEntitiesCount) {
      sendUXSEvent(device === 'desktop' ? companiesNames.desktop : companiesNames.mobile);
    }
  }, [device, entitiesCount, requiredEntitiesCount, companiesNames]);

  return { sendFavoritesUxfeedbackCampaign };
};
